<template>
  <div class="view contentBody">
    <div class="content">
      <div class="content-tab-box">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="item">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
      </div>
    </div>
  </div>
</template>
<script>
  import SettingsChat from "./SettingsChat.vue";
  import SettingsBottomNav from "./SettingsBottomNav.vue";
  import SettinsSpeech from "./SettinsSpeech.vue";
  import SettingsKnowledge from "./SettingsKnowledge.vue";
  let tabBox = {
    '话术库': {property: 'SettinsSpeech'},
    '聊天设置': {property: 'SettingsChat'},
    '底部导航': {property: 'SettingsBottomNav'},
    '知识库配置': {property: 'SettingsKnowledge'}
  }
  export default {
    name: "settings",
    components: {
      SettingsChat,
      SettingsBottomNav,
      SettinsSpeech,
      SettingsKnowledge
    },
    data() {
      return {
        meaulistTab: this.meaulist.meaulistGet(this, tabBox),
        activeName: ""
      };
    },
    created() {
      this.inittab();
    },
    methods: {
      inittab() {
        this.activeName =
            this.$route.query.tab !== undefined
                ? this.$route.query.tab
                : "SettinsSpeech";
      },
      tabCurrentFn(index) {
        this.meaulistTab.firstTab = index
      }
    }
  };
</script>
